import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

interface HighchartsChartProps {
  options: Highcharts.Options
  className?: string
}

export default function HighchartsChart({ options, className = '' }: HighchartsChartProps) {
  return (
    <div className={className}>
      <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />
    </div>
  )
}
